<template>
  <Transition name="offline-slide">
    <div
      v-if="!online"
      data-testid="offline-banner"
      role="status"
      aria-live="polite"
      class="offline-banner"
    >
      <WifiOff class="w-4 h-4 shrink-0" :stroke-width="2" />
      <span>Sin conexión a internet — reintentando cuando vuelva la señal…</span>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { WifiOff } from 'lucide-vue-next'
import { useOnlineStatus } from '~/composables/useOnlineStatus'

const { online } = useOnlineStatus()
</script>

<style scoped>
/* Barra fina fija al tope del viewport. Solo aparece sin conexión y desaparece al
 * reconectar. FIXED (no en flujo): los layouts usan `h-[100dvh] overflow-hidden`,
 * así que empujar el contenido lo recortaría 34px abajo (G-245). Overlay en su
 * lugar. Texto oscuro sobre ámbar claro (contraste AA). */
.offline-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 6px 12px;
  background: #fde68a; /* amber-200 */
  color: #451a03;      /* amber-950 — AA sobre amber-200 */
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
  z-index: 60; /* sobre topbar/modales (z-50), debajo de toasts críticos */
}

.offline-slide-enter-active,
.offline-slide-leave-active {
  transition: max-height .2s ease, opacity .2s ease;
  overflow: hidden;
  max-height: 60px;
}
.offline-slide-enter-from,
.offline-slide-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
